import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const CTA = <a href="#pricing" className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md font-medium transition-colors" data-id="element-135">
      Quiero vender
    </a>;
  return <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-sm border-b border-gray-100" data-id="element-136">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-137">
        <div className="flex justify-between items-center py-2 md:py-4" data-id="element-138">
          <div className="flex items-center" data-id="element-139">
            <a href="/" className="flex items-center" data-id="element-140">
              <span className="text-lg md:text-2xl font-bold bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent" data-id="element-141">
                MINGA
              </span>
            </a>
          </div>

          {/* Desktop navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-142">
            <a href="#features" className="text-gray-600 hover:text-blue-600 transition-colors" data-id="element-143">
              Cómo funciona la venta
            </a>
            <a href="#como-funciona" className="text-gray-600 hover:text-blue-600 transition-colors" data-id="element-144">
              Servicios
            </a>
            <a href="#testimonials" className="text-gray-600 hover:text-blue-600 transition-colors" data-id="element-145">
              Casos de éxito
            </a>
          </nav>

          <div className="hidden md:flex items-center" data-id="element-146">
            {CTA}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-147">
            <button type="button" className="text-gray-600 hover:text-blue-600" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-148">
              {mobileMenuOpen ? <XIcon className="h-5 w-5" data-id="element-149" /> : <MenuIcon className="h-5 w-5" data-id="element-150" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && <div className="md:hidden bg-white absolute w-full shadow-lg" data-id="element-151">
          <div className="pt-1 pb-2 px-4 space-y-1 sm:px-6 border-t border-gray-100" data-id="element-152">
            <a href="#features" className="block py-1.5 text-gray-600 hover:text-blue-600" onClick={() => setMobileMenuOpen(false)} data-id="element-153">
              Cómo funciona la venta
            </a>
            <a href="#como-funciona" className="block py-1.5 text-gray-600 hover:text-blue-600" onClick={() => setMobileMenuOpen(false)} data-id="element-154">
              Servicios
            </a>
            <a href="#testimonials" className="block py-1.5 text-gray-600 hover:text-blue-600" onClick={() => setMobileMenuOpen(false)} data-id="element-155">
              Casos de éxito
            </a>

            <div className="pt-1 pb-1" data-id="element-156">
              <a href="#pricing" className="block bg-blue-600 hover:bg-blue-700 text-white text-center px-3 py-1.5 rounded-md font-medium transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-157">
                Quiero vender
              </a>
            </div>
          </div>
        </div>}
    </header>;
};